export const finalRefundAmount = (selectedRefund, cancellationPreview) => {
  const { refundAmountFull, refundAmountPartial } = cancellationPreview;

  if (selectedRefund === 'full') return refundAmountFull;
  if (selectedRefund === 'partial') return refundAmountPartial;
  return null;
};

export const finalFormattedRefundAmount = (
  selectedRefund,
  cancellationPreview
) => {
  const { refundAmountFullFormatted, refundAmountPartialFormatted } =
    cancellationPreview;

  const formattedReturnValue = {
    full: refundAmountFullFormatted,
    partial: refundAmountPartialFormatted,
  };

  if (selectedRefund) return formattedReturnValue[selectedRefund];
  return null;
};

/**
 * Returns a dictionary of ticket type IDs to the number of guests for that ticket type
 * @param {Array} units - The units of the booking
 * @returns {Object} A dictionary of ticket type IDs to the number of guests for that ticket type
 */
export const getGuestsByTicketType = (units) => {
  if (Array.isArray(units) && units.length > 0) {
    return units.reduce((acc, u) => {
      const id = u.id != null ? Number(u.id) : NaN;
      const count = u.count != null ? Number(u.count) : 0;
      if (Number.isInteger(id) && id >= 0 && count > 0) {
        acc[id] = count;
      }
      return acc;
    }, {});
  }
  return {};
};
